import type {
  BookmarkInput,
  BookmarkMutationResponse,
  BookmarksResponse,
  DeleteBookmarkResponse,
} from "@learn-flow/contracts";
import { queryOptions } from "@tanstack/react-query";

import { apiRequest } from "../../lib/api.js";

export const bookmarksQueryKey = ["bookmarks"] as const;

export const bookmarksQueryOptions = queryOptions({
  queryKey: bookmarksQueryKey,
  queryFn: () => apiRequest<BookmarksResponse>("/api/v1/bookmarks"),
});

export function createBookmark(input: BookmarkInput): Promise<BookmarkMutationResponse> {
  return apiRequest("/api/v1/bookmarks", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateBookmark(
  bookmarkId: string,
  input: BookmarkInput,
): Promise<BookmarkMutationResponse> {
  return apiRequest(`/api/v1/bookmarks/${bookmarkId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteBookmark(bookmarkId: string): Promise<DeleteBookmarkResponse> {
  return apiRequest(`/api/v1/bookmarks/${bookmarkId}`, { method: "DELETE" });
}
